module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedThin.4f55481.woff";